import type { BATCH_ACTIONS } from 'pages/Batch/configs';
import type { IBatchData } from 'types/store';

export const PRESET_SCHEMA_VERSION = 3;

export type IPresetType = 'actions' | 'webhook';

export interface IPresetStep {
  action: BATCH_ACTIONS;
  params: Record<string, unknown>;
}

export interface IPresetPreview {
  url: string;
  width: number;
  height: number;
}

interface IPresetBase {
  id: string;
  schemaVersion: number;
  name: string;
  preview: IPresetPreview;
}

export interface IActionsPreset extends IPresetBase {
  type: 'actions';
  steps: IPresetStep[];
  createdAt: string;
  updatedAt: string;
  driveFolderId?: string;
}

export interface IWebhookPreset extends IPresetBase {
  type: 'webhook';
  flowId: string;
}

export type IPreset = IActionsPreset | IWebhookPreset;

export interface IRemotePresetShelf {
  id: string;
  title: string;
  presets: IPreset[];
}

export interface IPresetReplayStepResult {
  action: string;
  success: boolean;
  skipped?: boolean;
  skipReason?: string;
}

export interface IPresetReplayResult {
  completedSteps: number;
  skippedSteps: IPresetReplayStepResult[];
  errors: IPresetReplayStepResult[];
  processedData: IBatchData[];
}
